<template>
  <div>
    <label class="label">{{title}}</label>

    <label
      v-for="item in values"
      :key="item.value"
      class="radio"
      v-bind:class="{'state-disabled':disabled, 'state-error': model.$error, 'radio-inline': inline}"
    >
      <input
        type="radio"
        :checked="item.value === model.$model"
        :disabled="disabled"
        :value="item.value"
        @change="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        :name="model.$form.testPath ? model.$path : undefined"
      >
      <i></i>
      {{item.text}}
    </label>
    <label
      v-if="otherLabel"
      class="radio"
      v-bind:class="{'state-disabled':disabled, 'state-error': model.$error, 'radio-inline': inline}"
    >
      <input
        type="radio"
        :checked="otherIsClicked"
        :disabled="disabled"
        @change="onInputOther($event)"
        :name="model.$form.testPath ? model.$path : undefined"
      >
      <i></i>
      <span v-if="!otherIsClicked">{{otherLabel}}</span>
      <input v-else :value="model.$value" :placeholder="otherLabel">
    </label>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';

export default {
  mixins: [modelMixin],
  props: {
    values: {
      type: Array,
      default: []
    },
    otherLabel: {
      type: String
    }
  },
  data() {
    return {
      userOther: false
    };
  },
  computed: {
    otherIsClicked() {
      return this.userOther || (!this.values.map(x => x.value).includes(this.model.$value) && this.model.$value !== '');
    }
  },
  methods: {
    onInputOther(evt) {
      this.userOther = true;
      this.model.$value = '';
    },
    onInput(evt) {
      this.userOther = false;
      if (evt.target.checked) {
        this.model.$value = evt.target.value;
      }
    }
  }
};
</script>

<style>
</style>
